



































































































import { UserStore } from '@/store/modules/user';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { productNoPermissionList } from '@/api/product';
import AMSDialog from '@/components/AMSDialog.vue';
import AMSPagination, { PaginationModel } from '@/components/AMSPagination.vue';
import AMSTooltip from '@/components/AMSTooltip.vue';
import AMSProductCategorySelector from '@/components/AMSProductCategorySelector.vue';
import AMSBrandSelector from '@/components/AMSBrandSelector.vue';
import utils from '@/utils/utils';
@Component({
  name: 'ams-product-selector',
  components: {
    'ams-dialog': AMSDialog,
    'ams-pagination': AMSPagination,
    'ams-tooltip': AMSTooltip,
    'ams-product-category-selector': AMSProductCategorySelector,
    'ams-brand-selector': AMSBrandSelector
  }
})
export default class AMSProductSelector extends Vue {
  showDialog: boolean = false;
  totalCount: number = 0;
  headers: object[] = [
    { text: '商品', align: 'left', value: 'name', sortable: false },
    { text: '容量/规格', align: 'left', value: 'capacity', sortable: false },
    { text: '订货价', align: 'right', value: 'orderPrice', sortable: false, isCurrency: true }
  ];

  paging: PaginationModel = {
    descending: false,
    page: 0,
    rowsPerPage: 10, // -1 for All",
    totalItems: 0,
    pageSizes: [10, 15, 20, 30],
    sortBy: ''
  };
  /**搜索数据用的文本 */
  filteText: string = '';
  sortStr: string = '';

  /**当前页选中的商品*/
  selected: any[] = [];

  /**新选中的商品 */
  newSelected: any[] = [];

  /**文本框高度 */
  @Prop({ default: true }) showAsButton!: boolean;
  /**文本框宽度 */
  @Prop({ default: 150 }) width!: number;
  /**文本框高度 */
  @Prop({ default: 50 }) height!: number;
  /**表单验证规则 */
  @Prop({
    default: () => {
      return [];
    }
  })
  rules!: Array<any>;
  /**props */
  @Prop({
    default: () => {
      return [];
    }
  })
  value!: Array<any>;

  /**数据 */
  items: Array<any> = [];

  /**选中商品分类 */
  categoryId: string = '';
  /**选中的品牌 */
  brandId: any = {};
  
  isExternalShipper=false;//账户角色是否为外部仓库发货员
  /**商品分类验证规则 */
  get categoryRules() {
    return [];
  }

  /**商品品牌验证规则 */
  get brandRules() {
    return [];
  }
  /**文本框样式 */
  get textStyle() {
    return `width:${this.width}px;height:${this.height}px`;
  }

  /**显示选中的item */
  get name() {
    var name = '';
    if (this.$props.value) {
      this.$props.value.map((v: any, i: any) => {
        name = name + `${v.name};`;
      });
    }
    return name;
  }

  /**显示箭头 */
  get arrowIcon() {
    return this.showDialog ? 'arrow_drop_up' : 'arrow_drop_down';
  }
  created() {
    this.isExternalShipper = UserStore.isExternalShipper
    if(UserStore.isExternalShipper){//外部仓库发货员 角色账号下不显示订单金额
      this.headers.splice(2,1)
    }
  }
  formatPrice(num: number) {
    return utils.formatCurrencyPrice(num);
  }
  /**获取商品列表 */
  getProductList(isHandle = false, formData?: any) {
    const _this = this;
    if (isHandle) {
      _this.paging.page = 0;
    }
    var params = {
      // SkipCount: (_this.paging.page - 1 < 0 ? 0 : _this.paging.page - 1) * _this.paging.rowsPerPage, //当前页
      SkipCount: _this.paging.page * _this.paging.rowsPerPage, //当前页
      MaxResultCount: _this.paging.rowsPerPage, //每页大小
      Sorting: _this.sortStr,
      status: this.$route.path!.indexOf('addProduct') > 0 ? 'OnSale' : null
    };
    if (formData) {
      params = {
        ...params,
        ...formData
      };
    }
    productNoPermissionList(params).then((response: any) => {
      _this.totalCount = response.totalCount;
      _this.items = response.items;
      _this.paging.totalItems = response.totalCount;
      _this.genertateData();
    });
  }

  onPageChange(page: number) {
    this.paging.page = page;
    let data = {
      Filter: this.filteText,
      categoryId: this.categoryId,
      brandId: this.brandId.id
    };
    this.getProductList(false, data);
  }

  onPageSizeChange(size: number) {
    this.paging.rowsPerPage = size;
    let data = {
      Filter: this.filteText,
      categoryId: this.categoryId,
      brandId: this.brandId.id
    };
    this.getProductList(false, data);
  }

  /**显示隐藏弹窗 */
  onShowMenu() {
    this.showDialog = !this.showDialog;
  }

  /**点击了搜索按钮 */
  onSearch() {
    let data = {
      Filter: this.filteText,
      categoryId: this.categoryId,
      brandId: this.brandId.id
    };
    this.getProductList(true, data);
  }

  /**点击弹框的取消 */
  closeAMSDialog() {
    this.showDialog = false;
  }

  /**点击弹框的确定 */
  submitAMSDialog() {
    let seletedId: Array<string> = [];
    if (this.$props.value) {
      seletedId = this.$props.value.map((i: any) => {
        return i.productId || i.id;
      });
    }
    let newSelected = this.selected.filter(s => {
      return seletedId.indexOf(s.id) < 0;
    });
    this.$emit('input', newSelected.length === 0 ? [{}] : newSelected);
    this.showDialog = false;
    // if (this.$props.value) {
    //   var outside: any[] = this.$props.value;
    //   //如果外面的数组有商品就检查是否有这个商品，没有就添加
    //   if (outside.length > 0) {
    //     for (let i = 0; i < this.selected.length; i++) {
    //       const s = this.selected[i];
    //       var isExist = false;
    //       for (let j = 0; j < outside.length; j++) {
    //         const o = outside[j];
    //         if (o.id == s.id) {
    //           isExist = true;
    //         }
    //       }
    //       if (!isExist) {
    //         outside.push(s);
    //       }
    //     }
    //   }
    //   //如果外面的数组没有商品就直接添加
    //   else {
    //     this.$emit('input', this.selected);
    //   }
    // } else {
    //   this.$emit('input', this.selected);
    // }
    // this.showDialog = false;
  }

  /**重新生成一遍数据 */
  genertateData() {
    //检查一下新获取的商品里面有没有已经被选中的，如果有就禁用
    if (this.$props.value) {
      var outside: any[] = this.$props.value;
      var newItems: any[] = [];
      if (outside.length > 0) {
        outside.map((o, j) => {
          this.items.map((v, i) => {
            if (v.id == o.id || o.productId === v.id) {
              v.isDisable = true;
              this.selected.push(v);
            }
          });
        });
      }
    }
  }

  @Watch('showDialog', { immediate: true, deep: true })
  onMenuVisibleChange(newValue: boolean, oldValue: boolean) {
    if (newValue == true) {
      this.items = [];
      this.categoryId = '';
      this.brandId = {};
      this.filteText = '';
      this.getProductList();
    } else {
    }
  }
}
